import React, { useMemo } from 'react';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useConfigProvider } from '@/lib/context/ConfigProvider';
import './index.less';
const Breadcrumb = ({
  routes,
  className,
}: {
  routes: { text: string; path?: string }[];
  className?: string;
}) => {
  const { isMobile } = useConfigProvider();
  const items = useMemo(() => {
    return routes.map((route, index) => ({
      ...(index === routes.length - 1 ? {} : { href: route.path }),
      title: route.text,
    }));
  }, [routes]);

  return (
    <div
      className={classNames('breadcrumbs', className, {
        show: !isMobile,
      })}
    >
      <AntdBreadcrumb separator={<CaretRightOutlined />} items={items} />
    </div>
  );
};

export default Breadcrumb;
